import { ExportType } from '../export/export';
import { ExportConfiguration } from '../export/exportConfiguration';

export const TaskExportField = {
  company: 'company',
  barcode: 'barcode',

  productName: 'productName',
  productNumber: 'productNumber',

  binName: 'binName',
  stockLocationName: 'stockLocationName',

  containerIdentifier: 'containerIdentifier', // The scanned container identifier
  inContainer: 'inContainer', // Container where the product or container is stored

  lotNumber: 'lotNumber',
  lotExpiryDate: 'lotExpiryDate',

  serial: 'serial',
  serialManaged: 'serialManaged',

  lpn: 'lpn',
  lpnManaged: 'lpnManaged',

  kit: 'kit',
  kitManaged: 'kitManaged',

  countryOfOrigin: 'countryOfOrigin',

  assignedBy: 'assignedBy',

  countedAt: 'countedAt',
  countedBy: 'countedBy',

  expectedQuantity: 'expectedQuantity',
  countedQuantity: 'countedQuantity',
  quantityDifference: 'quantityDifference',
  discrepancy: 'discrepancy',
} as const;

export type TaskExportField = (typeof TaskExportField)[keyof typeof TaskExportField];

export class TaskExportConfiguration extends ExportConfiguration<TaskExportField> {
  discrepancyOnly: boolean = false;
  countedOnly: boolean = false;

  constructor(obj: any) {
    super(obj);
    this.discrepancyOnly = obj.discrepancyOnly || false;
    this.countedOnly = obj.countedOnly || false;
  }

  static default(companyId: string) {
    return new TaskExportConfiguration({
      companyId,
      name: '',
      filename: 'ventory_task_${TIMESTAMP}',
      type: ExportType.xlsx,
      discrepancyOnly: false,
      countedOnly: false,
      mapping: DEFAULT_MAPPING(),
    });
  }
}

const DEFAULT_MAPPING = () => {
  const map = new Map<TaskExportField, { value: string; index: number }>();
  map.set(TaskExportField.productName, { value: 'Product Name', index: 0 });
  map.set(TaskExportField.productNumber, {
    value: 'Product Number',
    index: 1,
  });
  map.set(TaskExportField.stockLocationName, {
    value: 'Stock Location',
    index: 2,
  });
  map.set(TaskExportField.binName, { value: 'Bin Name', index: 3 });
  map.set(TaskExportField.serial, { value: 'Serial', index: 4 });
  map.set(TaskExportField.countedAt, { value: 'Counted At', index: 5 });
  map.set(TaskExportField.countedBy, { value: 'Counted By', index: 6 });
  map.set(TaskExportField.expectedQuantity, {
    value: 'Expected Quantity',
    index: 7,
  });
  map.set(TaskExportField.countedQuantity, {
    value: 'Counted Quantity',
    index: 8,
  });
  map.set(TaskExportField.quantityDifference, {
    value: 'Quantity Difference',
    index: 9,
  });
  return map;
};
